import {inject, Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {BooxSessionService} from '../service';
import {BOOX_ROUTES} from '../token';


@Injectable({
  providedIn: 'root'
})
export class BooxNoSessionGuard implements CanActivate, CanActivateChild {

  private readonly router = inject(Router);
  private readonly sessionSrv = inject(BooxSessionService);
  private readonly routes = inject(BOOX_ROUTES);

  /**
   * checks if the user is not authenticated if so, it will redirect to the home page
   * @param route
   * @param state
   * @returns
   */
  private handle(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    debugger;
    if (!this.sessionSrv.isAuthenticated) return true;

    if (!this.routes?.home?.length) {
      console.error(`Has no home route.`);
      return false;
    }

    const targetPath = this.routes.home.filter(Boolean).join('/');
    const currentPath = state.url.replace(/^\//, '');

    if(currentPath === targetPath) return true;

    return this.router.createUrlTree(this.routes.home);

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.handle(route, state);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.handle(childRoute, state);
  }
}
